import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=50869f4c&lang=pug&"
import script from "./FeedbackPage.vue?vue&type=script&lang=js&"
export * from "./FeedbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports